import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"margin-bottom":"100px"}
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-2 col-6" }
const _hoisted_7 = { class: "col-md-2 col-6" }
const _hoisted_8 = { class: "col-md-2 col-6" }
const _hoisted_9 = { class: "col-md-2 col-6" }
const _hoisted_10 = { class: "col-md-2 col-6" }
const _hoisted_11 = { class: "col-md-2 col-6" }
const _hoisted_12 = { class: "col-md-12 table-responsive" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_14 = { class: "p-4" }
const _hoisted_15 = { class: "fw-14 text-danger" }
const _hoisted_16 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_17 = { class: "mb-1 text-muted f12px" }
const _hoisted_18 = {
  class: "table-sm table-bordered",
  id: "tabela-relatorio"
}
const _hoisted_19 = { class: "text-start text-truncate colNome" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center text-nowrap" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "border-top" }
const _hoisted_32 = { class: "text-end fw-bold" }
const _hoisted_33 = { class: "text-end fw-bold" }
const _hoisted_34 = { class: "text-end fw-bold" }
const _hoisted_35 = {
  key: 0,
  class: "row"
}
const _hoisted_36 = { class: "col-md-12 text-center" }
const _hoisted_37 = { class: "row mt-2" }
const _hoisted_38 = { class: "col-md-12 text-center" }
const _hoisted_39 = { class: "" }
const _hoisted_40 = { class: "text-danger fw-bold" }

import { onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/relatoriosService";
import * as mensalidadesService from "@/services/mensalidadesService";
import { fdata, f2dec, fdataUS, fDifData } from "@/utils/funcoes";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


//vue
const route = useRoute();

var controle = reactive({

  filtros: {
    nome: "",
    ano: 2026 ,
    mes: 7,
    status: "A Receber",
  } as unknown as service.FiltroMensalidades,
  cidadeId: null as number | null,
  itens: [] as service.RelMensDTO[],

  ordenarPor: "dataPagamento",
  ordenarDir: "asc",

  totalRegistros: 0,

  qtdeRegistros: 0,
  qtdePagos: 0,
  qtdeEmAberto: 0,
  qtdeVencidos: 0,

  totalGeral: 0,
  totalPago: 0,
  totalEmAberto: 0,
  totalVencido: 0,
  totalAcresDesc: 0,

  erro: "",
  status: "",
  pesquisando: false,

  janConfirmaPagamento: false,
  itemPagando: null as service.RelMensDTO | null,
  statusPagamento: "",
  erroPagamento: "",
})

onMounted(() => {

  if (route.params.id != null && route.params.id !== "") {
    controle.filtros.contratoId = parseInt(route.params.id.toString());
    controle.filtros.ano = null;
    controle.filtros.mes = null;
    controle.filtros.status = null;
  }
  else 
  {
    controle.filtros.ano = parseInt(new Date().getFullYear().toString());
    controle.filtros.mes = parseInt((new Date().getMonth() + 1).toString().padStart(2, '0'));
  }
  pesquisar();
})

async function pesquisar() {

  if (controle.cidadeId != null && controle.cidadeId > 0) {
    controle.filtros.cidadesIds = [controle.cidadeId];
  } else {
    controle.filtros.cidadesIds = null;
  }

  if (controle)

  service.mensalidades(controle.filtros)
    .then(r => {
      controle.itens = r.dados;
      ordenarPor("dataPagamento");

      controle.totalRegistros = r.totalRegistros;
      controle.pesquisando = false;

      controle.qtdeRegistros = controle.itens.length;
      controle.qtdeEmAberto = 0;
      controle.qtdePagos = 0;
      controle.qtdeVencidos = 0;

      controle.totalGeral = 0;
      controle.totalEmAberto = 0;
      controle.totalPago = 0;
      controle.totalVencido = 0;
      controle.totalAcresDesc = 0;

      controle.itens.forEach(a => {

        controle.totalGeral += a.valor;

        if (a.dataPagamento != null) {
          controle.qtdePagos += 1;
          controle.totalPago += a.valorPago;
          controle.totalAcresDesc += a.valorPago - a.valor;
        }

      });

    })
    .catch(erro => {
      controle.erro = erro;
      controle.pesquisando = false;
    })
}

const ordenarPor = (coluna: string) => {

  controle.itens = controle.itens.sort((a, b) => {
    return (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0);
  }) as service.RelMensDTO[];
}

function boleto(item: service.RelMensDTO) {
  if (item.boletoId == null) {
    controle.erro = "Boleto não gerado.";
    return;
  }
  else
  {
    const urlBase = `${config.urlApi}`

    var url = `${urlBase}/Boletos/Ver/${item.boletoId}`;
    
    if (item.boletoAntigo)
      url = `${urlBase}/Boletos/VerAntigo/${item.boletoId}`;

    window.open(url, '_blank');
  }
}

function confirmarPagamento(item: service.RelMensDTO) {
  controle.itemPagando = item;
  controle.erroPagamento = "";
  controle.janConfirmaPagamento = true;
}

function pagarConfirmado() {
  if (!controle.itemPagando) return;

  controle.statusPagamento = "Registrando pagamento...";
  controle.erroPagamento = "";

  mensalidadesService.pagar(controle.itemPagando.id)
    .then(() => {
      controle.statusPagamento = "";
      controle.itemPagando = null;
      pesquisar();
    })
    .catch((error) => {
      controle.erroPagamento = `Erro ao registrar pagamento: ${error.message || error}`;
      controle.statusPagamento = "";
    });
}

function pix(item: service.RelMensDTO) {
  
  if (item != null)
  {
    controle.erro = "Desativado";
    return;
    
  }
  
  if (item.boletoId == null) {
    controle.erro = "PIX não gerado.";
    return;
  }
  else
  {
    const urlBase = `${config.urlApi}`

    var url = `${urlBase}/Boletos/Ver/${item.boletoId}`;

    window.open(url, '_blank');
  }
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Contas a Receber",
      items: [
    { label: 'Relatorios', to: '/' }]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro = '')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "Nome ou CPF", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
                      class: "form-control form-control-sm",
                      id: "nome",
                      type: 'text',
                      onInput: pesquisar
                    }, null, 544), [
                      [_vModelDynamic, _unref(controle).filtros.nome]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", null, "Nro Contrato", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.contratoId) = $event)),
                      class: "form-control form-control-sm",
                      id: "contrato",
                      type: 'text',
                      onInput: pesquisar
                    }, null, 544), [
                      [_vModelDynamic, _unref(controle).filtros.contratoId]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", null, "Mês", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).filtros.mes) = $event)),
                      class: "form-select form-select-sm",
                      id: "mes",
                      onChange: pesquisar
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("option", { value: null }, "Todos", -1),
                      _createElementVNode("option", { value: 1 }, "Janeiro", -1),
                      _createElementVNode("option", { value: 2 }, "Fevereiro", -1),
                      _createElementVNode("option", { value: 3 }, "Março", -1),
                      _createElementVNode("option", { value: 4 }, "Abril", -1),
                      _createElementVNode("option", { value: 5 }, "Maio", -1),
                      _createElementVNode("option", { value: 6 }, "Junho", -1),
                      _createElementVNode("option", { value: 7 }, "Julho", -1),
                      _createElementVNode("option", { value: 8 }, "Agosto", -1),
                      _createElementVNode("option", { value: 9 }, "Setembro", -1),
                      _createElementVNode("option", { value: 10 }, "Outubro", -1),
                      _createElementVNode("option", { value: 11 }, "Novembro", -1),
                      _createElementVNode("option", { value: 12 }, "Dezembro", -1)
                    ]))], 544), [
                      [_vModelSelect, _unref(controle).filtros.mes]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", null, "Ano", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).filtros.ano) = $event)),
                      class: "form-select form-select-sm",
                      id: "ano",
                      onChange: pesquisar
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("option", { value: null }, "Todos", -1),
                      _createElementVNode("option", { value: '2022' }, "2022", -1),
                      _createElementVNode("option", { value: '2023' }, "2023", -1),
                      _createElementVNode("option", { value: '2024' }, "2024", -1),
                      _createElementVNode("option", { value: '2025' }, "2025", -1),
                      _createElementVNode("option", { value: '2026' }, "2026", -1),
                      _createElementVNode("option", { value: '2027' }, "2027", -1),
                      _createElementVNode("option", { value: '2028' }, "2028", -1),
                      _createElementVNode("option", { value: '2029' }, "2029", -1),
                      _createElementVNode("option", { value: '2030' }, "2030", -1),
                      _createElementVNode("option", { value: '2031' }, "2031", -1),
                      _createElementVNode("option", { value: '2032' }, "2032", -1)
                    ]))], 544), [
                      [_vModelSelect, _unref(controle).filtros.ano]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", null, "Status", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).filtros.status) = $event)),
                      class: "form-select form-select-sm",
                      id: "status",
                      onChange: pesquisar
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("option", { value: null }, "Todos", -1),
                      _createElementVNode("option", { value: 'A Receber' }, "Em Aberto", -1),
                      _createElementVNode("option", { value: 'Vencidas' }, "Vencidas", -1),
                      _createElementVNode("option", { value: 'Pago' }, "Pago", -1)
                    ]))], 544), [
                      [_vModelSelect, _unref(controle).filtros.status]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("a", {
                      class: "btn btn-primary btn-sm mt-4",
                      onClick: pesquisar
                    }, "Pesquisar"),
                    _createVNode(_component_RouterLink, {
                      class: "btn btn-sm btn-secondary float-end mt-4",
                      to: '/'
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("Fechar", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_unref(controle).erro != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(controle).erro), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(controle).erro == '' && _unref(controle).pesquisando == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("div", { class: "p-4" }, [
                      _createElementVNode("i", { class: "fa fa-cog fa-2x fa-spin" }),
                      _createElementVNode("div", { class: "fw-16" }, "Pesquisando...")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(controle).erro == '' && _unref(controle).pesquisando == false)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_17, "Total: " + _toDisplayString(_unref(controle).totalRegistros) + " registro(s)", 1),
                    _createElementVNode("table", _hoisted_18, [
                      _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", { class: "table-relatorio" }, [
                          _createElementVNode("th", { class: "text-start text-truncate colNome" }, "Nome"),
                          _createElementVNode("th", { class: "text-end" }, "Cliente"),
                          _createElementVNode("th", { class: "text-center" }, [
                            _createTextVNode("Parcela "),
                            _createElementVNode("br"),
                            _createTextVNode(" Contrato")
                          ]),
                          _createElementVNode("th", { class: "text-end" }, "Valor R$"),
                          _createElementVNode("th", { class: "text-end" }, "Pago R$"),
                          _createElementVNode("th", { class: "text-end" }, [
                            _createTextVNode("Acres"),
                            _createElementVNode("br"),
                            _createTextVNode("Desc R$")
                          ]),
                          _createElementVNode("th", { class: "text-center" }, "Vencimento"),
                          _createElementVNode("th", { class: "text-center" }, "Pagamento"),
                          _createElementVNode("th", { class: "text-center" }, "Dias Atraso"),
                          _createElementVNode("th", { class: "text-center" }, "Opções")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                            _createElementVNode("td", _hoisted_19, _toDisplayString(item.clienteNome), 1),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(item.clienteId), 1),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(item.parcela) + " / " + _toDisplayString(item.contratoId), 1),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(f2dec)(item.valor)), 1),
                            _createElementVNode("td", {
                              class: _normalizeClass(["text-end", item.valorPago > 0 ? 'fw-bold' : ''])
                            }, _toDisplayString(_unref(f2dec)(item.valorPago)), 3),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(f2dec)(item.valorPago > 0 ? item.valorPago - item.valor : 0)), 1),
                            _createElementVNode("td", _hoisted_24, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge rounded-pill",  _unref(fDifData)(new Date(), item.dataVencimento) > 0 ? 'badge-soft-danger': 'badge-soft-primary'])
                              }, _toDisplayString(_unref(fdata)(item.dataVencimento)), 3)
                            ]),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(fdata)(item.dataPagamento)), 1),
                            _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(fDifData)(new Date(), item.dataVencimento)), 1),
                            _createElementVNode("td", _hoisted_27, [
                              (item.boletoId  && item.dataPagamento == null && item.podeImprimir)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: _normalizeClass(["btn btn-sm me-1", item.boletoAntigo ? 'btn-primary' : 'btn-danger']),
                                    title: "Imprimir boleto",
                                    onClick: ($event: any) => (boleto(item))
                                  }, [...(_cache[19] || (_cache[19] = [
                                    _createElementVNode("i", { class: "fa fa-barcode" }, null, -1),
                                    _createTextVNode(" Boleto ", -1)
                                  ]))], 10, _hoisted_28))
                                : _createCommentVNode("", true),
                              (item.boletoId  && item.dataPagamento == null && item.podeImprimir)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "btn btn-sm btn-primary me-1",
                                    title: "Obter código Pix",
                                    onClick: ($event: any) => (pix(item)),
                                    disabled: ""
                                  }, [...(_cache[20] || (_cache[20] = [
                                    _createElementVNode("i", { class: "fa fa-qrcode" }, null, -1),
                                    _createTextVNode(" Pix ", -1)
                                  ]))], 8, _hoisted_29))
                                : _createCommentVNode("", true),
                              (item.dataPagamento == null)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    class: "btn btn-sm btn-success",
                                    title: "Pagar",
                                    onClick: ($event: any) => (confirmarPagamento(item))
                                  }, [...(_cache[21] || (_cache[21] = [
                                    _createElementVNode("i", { class: "fa fa-check" }, null, -1),
                                    _createTextVNode(" Pagar ", -1)
                                  ]))], 8, _hoisted_30))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("tr", _hoisted_31, [
                          _cache[22] || (_cache[22] = _createElementVNode("td", null, null, -1)),
                          _cache[23] || (_cache[23] = _createElementVNode("td", null, null, -1)),
                          _cache[24] || (_cache[24] = _createElementVNode("td", null, null, -1)),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(_unref(f2dec)(_unref(controle).totalGeral)), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(f2dec)(_unref(controle).totalPago)), 1),
                          _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(f2dec)(_unref(controle).totalAcresDesc)), 1),
                          _cache[25] || (_cache[25] = _createElementVNode("td", null, null, -1)),
                          _cache[26] || (_cache[26] = _createElementVNode("td", null, null, -1))
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janConfirmaPagamentoContasReceber',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janConfirmaPagamento,
      titulo: 'Atenção',
      onOnFechou: _cache[7] || (_cache[7] = ($event: any) => {_unref(controle).janConfirmaPagamento = false; _unref(controle).itemPagando = null}),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[8] || (_cache[8] = ($event: any) => (pagarConfirmado()))
    }, {
      default: _withCtx(() => [
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Confirma o pagamento? ")
        ], -1)),
        (_unref(controle).itemPagando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(controle).itemPagando.clienteNome) + " - Parcela " + _toDisplayString(_unref(controle).itemPagando.parcela) + " - R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).itemPagando.valor)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(controle).statusPagamento), 1),
            _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(controle).erroPagamento), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})